module.exports = __webpack_public_path__ + "static/media/hollow_bar_M2.063cd7af.svg";